import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {CmsConfig, ConfigModule, I18nModule, provideDefaultConfig, RoutingConfig} from '@spartacus/core';
import {CmsPageGuard, MediaModule, PageLayoutComponent} from '@spartacus/storefront';

import {AimoBreadcrumbModule} from '../navigation/breadcrumb/aimo-breadcrumb.module';
import {AimoSpinnerModule} from '../shared/spinner/aimo-spinner.module';

import {AimoBulletinHeaderComponent} from './aimo-bulletin-header.component';
import {AimoBulletinListComponent} from './aimo-bulletin-list.component';
import {AimoBulletinComponent} from './aimo-bulletin.component';
import {AimoPipesModule} from "../shared/utils/safe-html/aimo-pipes.module";

@NgModule({
    imports: [
        I18nModule,
        CommonModule,
        RouterModule,
        ConfigModule.withConfig(<CmsConfig>{
            cmsComponents: {
                BulletinListComponent: {
                    component: AimoBulletinListComponent,
                },
                AimoBulletinListComponent: {
                    component: AimoBulletinListComponent,
                },
                AimoBulletinHeaderComponent: {
                    component: AimoBulletinHeaderComponent,
                },
                BulletinComponent: {
                    component: AimoBulletinComponent,
                },
                AimoBulletinComponent: {
                    component: AimoBulletinComponent,
                },
            },
        }),
        MediaModule,
        NgbPopoverModule,
        AimoSpinnerModule,
        AimoBreadcrumbModule,
        AimoPipesModule,
        RouterModule.forChild([
            {
                // @ts-ignore
                path: null,
                canActivate: [CmsPageGuard],
                component: PageLayoutComponent,
                data: {
                    cxRoute: 'announcements',
                },
            },
            {
                // @ts-ignore
                path: null,
                canActivate: [CmsPageGuard],
                component: PageLayoutComponent,
                data: {
                    cxRoute: 'announcementDetails',
                },
            },
        ]),
    ],
    declarations: [AimoBulletinListComponent, AimoBulletinHeaderComponent, AimoBulletinComponent],
    exports: [AimoBulletinListComponent, AimoBulletinHeaderComponent, AimoBulletinComponent],
    providers: [
        provideDefaultConfig(<RoutingConfig>{
            routing: {
                routes: {
                    announcements: {
                        paths: ['announcements'],
                    },
                    announcementDetails: {
                        paths: ['announcements/:announcementId'],
                        paramsMapping: {announcementId: 'announcementId'},
                    },
                },
            },
        }),
    ],
})
export class AimoBulletinsModule {
}
